var render = function render(){var _vm=this,_c=_vm._self._c;return _c('billing-report-panel',{attrs:{"report-key":"statement-check","route":"/reports/billing-statement-check","file-name":"conferencia-do-demonstrativo.xlsx","period-label":"Período de fechamento do lote","columns":_vm.columns,"status-options":_vm.statusOptions,"show-status":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }